export default "__VITE_ASSET__DBFUmySs__"